import React, { useState } from 'react';
import { Filter } from 'lucide-react';
import { Button, CardHeader, CardTitle } from '@cargomatic/ui';
import { FilterBar } from './FilterBar';
/**
 * Card header with a title, filter toggle, optional inline search, action
 * buttons, and a collapsible FilterBar.
 *
 * Usage:
 * ```
 * <FilterCardHeader
 *   title="Shipments"
 *   search={<Input placeholder="Search shipments…" />}
 *   actions={<BulkActions />}
 *   onReset={resetFilters}
 * >
 *   <StatusFilter ... />
 *   <DateRangeFilter ... />
 * </FilterCardHeader>
 * ```
 */
export function FilterCardHeader({ title, search, actions, onReset, children, defaultOpen = true, className, }) {
    const [showFilters, setShowFilters] = useState(defaultOpen);
    return (React.createElement(CardHeader, { className: className },
        React.createElement("div", { className: "flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between" },
            React.createElement("div", { className: "flex flex-1 flex-wrap items-center gap-2 min-w-0" },
                React.createElement(CardTitle, { className: "text-lg font-semibold" }, title),
                React.createElement(Button, { variant: showFilters ? 'secondary' : 'ghost', size: "sm", onClick: () => setShowFilters((prev) => !prev), className: "h-8 w-8 p-0", "aria-label": "Toggle filters", "aria-expanded": showFilters },
                    React.createElement(Filter, { className: "size-4" })),
                search && React.createElement("div", { className: "min-w-0 flex-1 sm:max-w-xs" }, search)),
            actions && (React.createElement("div", { className: "flex flex-wrap items-center gap-2" }, actions))),
        showFilters && React.createElement(FilterBar, { onReset: onReset }, children)));
}
